require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tags-entrepreneurship.json") })
        }
      }, "path---tags-entrepreneurship");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tags-entrepreneurship!./.cache/json/tags-entrepreneurship.json
// module id = 323
// module chunks = 231608221292675